export const PaperProps = {
  sx: {
    maxWidth: 'unset',
    width: '613px',
    maxHeight: 'auto',
  },
};

export const PaperProps2 = {
  sx: {
    maxWidth: 'unset',
    width: '600px',
    maxHeight: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
  },
};

export const subjects = ['Math', 'Science', 'English', 'Social'];

export const selectSubjectDate = 'Please select subject and date'
export const bookTutoringSessionConfirmation = 'Are you sure you want to book this slot ?'
export const weekDaysMessage =
  '(You May Select Up to 2 - 15 minute time slots per day)';

export const weekendDaysMessage =
  'No time slots available on this day; please choose another.';

export const cardListColors = ['#4CAF50', '#2196F3', '#fb8c00', '#f44336', '#9c27b0'];

export const NO_SESSIONS_TEXT = 'No sessions are currently booked.';
export const NO_ANNOUNCEMENTS_TEXT = 'Currently, there are no announcements.';